import { memo } from 'react';
import { Link } from 'react-router-dom';

import trusted from '../../../../../data/imagesTrusted';

import Styles from '../styles.module.scss';

const TrustedSection = (props) => {
  const { brokers } = props;

  return (
    <section className={`${Styles.trusted} ${Styles.first_block} ${brokers ? Styles.brokers_page : ''}`}>
      <h3 className={`${Styles.title} text-uppercase`}>trusted by</h3>
      <h5 className={Styles.institutions}>
        Financial institutions, startups, and 300k+ users
      </h5>
      <div className={Styles['homepage-logos']}>
        {trusted.map(({
          logo,
          id,
          width,
          height,
        }) => (
          <div className={Styles.logo} key={id}>
            <img
              width={width}
              height={height}
              src={logo}
              alt=""
              loading="lazy"
            />
          </div>
        ))}
      </div>
      {!brokers && (
        <div className={Styles['trusted-join']}>
          <p>
            What about
            {' '}
            <span>YOU?</span>
          </p>
          <Link to="/products/api/financial-news/pricing-api/commercial">Join Them</Link>
        </div>
      )}
    </section>
  );
};

export default memo(TrustedSection);
